import { useEffect, useState } from "react";
import { Alert } from "react-bootstrap";
import { getSystemNotices } from "../../services/apiClient.js";

// The system-notices pipeline's render surface (services/systemNotices.js):
// silent-decay warnings that need a human (holiday horizon today; add rules
// server-side and they appear here automatically). Renders nothing when the
// system is healthy — most days this component is invisible.
function SystemNotices() {
  const [notices, setNotices] = useState([]);

  useEffect(() => {
    getSystemNotices().then(setNotices).catch(() => {});
  }, []);

  if (notices.length === 0) return null;
  return (
    <>
      {notices.map((n) => (
        <Alert key={n.key} variant={n.level} className="py-2">
          <span className="fw-semibold">{n.title}</span>
          {n.detail ? <span className="ms-2 small">{n.detail}</span> : null}
        </Alert>
      ))}
    </>
  );
}

export default SystemNotices;
